import onboarding from '../../assets/images/chot-buddies/onboarding1_ios.png';
import homeList from '../../assets/images/chot-buddies/home_menu_tab_1.jpg';
import buddyDetails from '../../assets/images/chot-buddies/Screenshot_1757521222.png';
import cocoChat from '../../assets/images/chot-buddies/iphone-3-coco-chat.png';
import remyChat from '../../assets/images/chot-buddies/iphone-4-remy-chat.png';
import selectPrompt from '../../assets/images/chot-buddies/iphone-5-select-prompt.png';
import voiceMode from '../../assets/images/chot-buddies/iphone-6-voice-mode-starting.png';
import ipadLineup from '../../assets/images/chot-buddies/ipad-1-buddies-lineup.png';
import ipadChat from '../../assets/images/chot-buddies/ipad-2-remy-chat.png';
import ipadPrompts from '../../assets/images/chot-buddies/ipad-3-select-prompt.png';

export interface GalleryItem {
  src: string;
  label: string;
}

export const GALLERY_ITEMS: GalleryItem[] = [
  { src: onboarding,   label: 'Meet your buddies' },
  { src: homeList,     label: 'Pick your companion' },
  { src: buddyDetails, label: 'Know each specialist' },
  { src: cocoChat,     label: 'Ask anything' },
  { src: remyChat,     label: 'Plan your next trip' },
  { src: selectPrompt, label: 'Prompt ideas built in' },
  { src: voiceMode,    label: 'Talk it out in voice mode' },
  { src: ipadLineup,   label: 'Every buddy, one tap away' },
  { src: ipadChat,     label: 'Made for iPad' },
  { src: ipadPrompts,  label: 'Prompts on a bigger screen' },
];
